import { render, staticRenderFns } from "./yichengnuo.vue?vue&type=template&id=37556abe&scoped=true&"
import script from "./yichengnuo.vue?vue&type=script&lang=js&"
export * from "./yichengnuo.vue?vue&type=script&lang=js&"
import style0 from "./yichengnuo.vue?vue&type=style&index=0&id=37556abe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37556abe",
  null
  
)

export default component.exports